import React from 'react';
export function HEMDefinedSection() {
  return <section data-id="element-2868">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2869">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2870">
          High-Efficiency Milling Defined
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-8" data-id="element-2871">
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-2872">
          HEM is a milling technique for roughing that utilizes a lower Radial
          Depth of Cut (RDOC) and a higher Axial Depth of Cut (ADOC). This
          spreads wear evenly across the cutting edge, dissipates heat, and
          reduces the chance of tool failure.
        </p>

        <div className="text-center py-4" data-id="element-2873">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/Conventional%20Milling%20vs.%20HEM%20-%20High%20Efficiency%20Milling.png800x800.png" alt="Conventional Milling vs. HEM" className="mx-auto max-w-3xl w-full h-auto rounded-lg shadow-sm border border-gray-200 block" data-id="element-2874" />
        </div>

        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-2875">
          This strategy differs from traditional or conventional milling, which
          typically calls for a higher RDOC and lower ADOC. Traditional milling
          causes heat concentrations in one small portion of the cutting tool,
          expediting the tool wear process. Further, while Traditional Milling
          call for more axial passes, HEM toolpaths use more passes radially.
        </p>
      </div>
    </section>;
}